import React from "react";
import { Loader2, Save } from "lucide-react";

const inputCls =
  "w-full bg-transparent border-b border-navy/20 py-2.5 text-navy placeholder:text-navy/35 focus:outline-none focus:border-gold transition-colors";

// Labelled text input bound to an object field.
export function Field({ label, value, onChange, placeholder, textarea, rows = 3 }) {
  return (
    <div>
      <label className="block text-[0.62rem] uppercase tracking-[0.18em] text-navy/45 mb-2">{label}</label>
      {textarea ? (
        <textarea
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          rows={rows}
          placeholder={placeholder}
          className={`${inputCls} resize-none`}
        />
      ) : (
        <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className={inputCls} />
      )}
    </div>
  );
}

// Section header + save button, shown at the top of each editor panel.
export function SaveBar({ title, description, saving, onSave }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 pb-6 border-b border-navy/10">
      <div>
        <h2 className="font-serif font-light text-3xl text-navy">{title}</h2>
        {description && <p className="text-navy/55 text-sm mt-1">{description}</p>}
      </div>
      <button
        onClick={onSave}
        disabled={saving}
        className="inline-flex items-center gap-2 bg-navy text-paper px-6 py-3 text-xs uppercase tracking-[0.2em] hover:bg-gold transition-colors disabled:opacity-60 shrink-0"
      >
        {saving ? <Loader2 size={15} className="animate-spin" /> : <Save size={15} />} Salva modifiche
      </button>
    </div>
  );
}
